import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        if (state.url.includes(`${ROUTE_NAMES.RESET_PASSWORD}`)) {
          authService.clearSessionStorage();
          return of(true);
        }

        if (authenticated) {
          return of(router.parseUrl(''));
        }

        return of(true);
      })
    );
};
